import React, { useEffect, useRef, useState } from 'react';
import { Col } from 'antd';
import './HeaderStyle.scss';
import 'antd/dist/antd.css';
import { images } from 'src/assets/img/index.js';
import { Header } from 'antd/lib/layout/layout';

const HeaderPage = () => {
	return (
		<>
			<Col xl={24} lg={24} md={24} sm={24} xs={24}>
				{/* <img src={images.edenredlog} style={{ width: '80px' }} /> */}

				<div className="header_style_container">
					<img src={images.edenredlog} style={{ width: '80px' }} />
				</div>
			</Col>
		</>
	);
};
export default HeaderPage;
